export function readjustGroupedElements(mglBars: HTMLElement[], groupElements: HTMLElement[]) {
  if (mglBars.some((editBar) => !editBar.hasAttribute('aria-hidden'))) {
    groupElements.forEach((element) => {
      element.setAttribute('bars-visible', '');
    });
  }
}
